import React from 'react';
import { titleCase, get } from "@dex/bubl-helpers";
import CampAttendanceApi from './CampAttendanceApi';
import ModelLink from '@dex/bubl-dash/src/lib/components/ModelLink/ModelLink';

let settings;

export default settings = {
    key: 'camp/attendance',
    zone: 'camp',
    path: '/camp/attendance',
    title: "Camp Attendance",
    endpoint: CampAttendanceApi.endpoint,
    modelName: 'CampAttendance',
    idKey: 'id',
    primaryKey: 'title',
    indexCaps: ["viewCampAttendance"],
    viewCaps: ["viewCampAttendance"],
    createCaps: ["createCampAttendance"],
    updateCaps: ["updateCampAttendance"],
    indexTitle: (routeName, params, users) => {

        let title: string = settings.title;

        if (params && params.name) title = title + " / " + titleCase(params.name);

        return title;

    },
    indexTabs: (routeName, params, users) => {

        return [
            {
                label: "All",
                path: settings.path,
                caps: settings.indexCaps
            },
            // {
            //     label: "Add New",
            //     path: settings.path + "/create",
            //     caps: settings.createCaps
            // },
        ]

    },
    indexButtons: (routeName, params, users) => {

        return [
            // {
            //     label: "Add New",
            //     path: settings.path + '/create',
            //     caps: settings.createCaps
            // }
        ]

    },
    indexTabCounts: (routeName, params, dontation) => {

        return settings.endpoint + "/getCounts";

    },
    indexFetch: CampAttendanceApi.get,
    indexFetchParams: (routeName, params, users) => {

        const filters: any = { where: {}, include: ['owner', 'host', 'operator', 'sessionGroup', 'assessment', 'session', 'pass', 'athlete'], order: ['joinedOn.date DESC'], limit: 10, skip: 0 };

        if (params && params.status) filters.where.status = { inq: [params.status] };

        return filters;

    },
    indexQuickSearch: (routeName, params, users) => {

        const fields = ['id'];

        return fields;

    },
    indexSearchFields: (routeName, params, users) => {

        const fields = [
            {
                label: "Session Date",
                key: "sessionDate",
                type: "date",
            },
            {
                label: "Customer",
                key: "owner",
                type: "relationship",
                model: "Users"
            },
            {
                label: "Athlete",
                key: "athlete",
                type: "relationship",
                model: "CampAthletes"
            },
            {
                label: "Host",
                key: "host",
                type: "relationship",
                model: "Hosts"
            },
            {
                label: "Session Group",
                key: "sessionGroup",
                type: "relationship",
                model: "CampSession"
            },
            {
                label: "Session",
                key: "session",
                type: "relationship",
                model: "CampSession"
            },

        ];

        return fields;

    },

    indexColumns: (routeName, params, users) => {

        const columns = [
            // {
            //     label: "",
            //     key: "this",
            //     // format: "ModelLink",
            //     render: (value, data) => {
            //         return <ModelLink modelName="CampAttendance" data={{ id: data.id, title: "View Attendance" }} />
            //     }
            // },
            {
                label: "Session",
                key: "session",
                format: "ModelLink",
            },
            {
                label: "Athlete",
                key: "athlete",
                format: "ModelLink"
            },
            {
                label: "Status",
                key: "cancelled",
                render: (value, data) => {
                    if (data.cancelled) return "Cancelled";
                    else if (data.attended) return "Attended";
                    else return "Attending";
                }
            },
            {
                label: "Customer",
                key: "owner",
                format: "ModelLink",
            },
            {
                label: "Host",
                key: "host",
                format: "ModelLink"
            },
            {
                label: "Session Group",
                key: "sessionGroup",
                format: "ModelLink"
            },
            {
                label: "Joined On",
                key: "joinedOn",
                format: "OnAndBy",
                sort: "joinedOn.date",
                alignEnd: true
            },
            {
                label: "Actions",
                key: "actions",
                alignEnd: true,
                format: "actions",
                api: CampAttendanceApi,
                settings: settings,
            }
        ];

        return columns;

    },

    indexExportFormats: (routeName, params, user) => {

        const formats = [
            { value: "campAttendance", label: "Camp Attendance" }
        ];

        return formats;

    },

    singleFetch: CampAttendanceApi.getOne,
    singleFetchParams: (routeName, params, users, fetch) => {

        const filters = { include: ['owner', 'host', 'operator', 'sessionGroup', 'assessment', 'session', 'pass', 'athlete'] };

        return filters;

    },
    singleTitle: (routeName, params, users, fetch) => {

        let title: string = "Loading...";

        const complete = get(fetch, 'complete');
        const error = get(fetch, 'error');
        const data = get(fetch, 'data');

        if (error) title = "Error";
        else if (data) title = data[settings.primaryKey];
        else if (complete && !data) title = "Not Found";

        return title;

    },
    singleTabs: (routeName, params, users, fetch) => {

        const path = settings.path + "/" + params.id;

        return [
            {
                label: "View",
                path: path + "/view"
            },
            // {
            //     label: "Edit",
            //     path: path + "/edit",
            //     caps: settings.updateCaps
            // },
        ]

    },
};